// import axios from "axios";
import { createStore } from "vuex";
import createPersistedState from "vuex-persistedstate";
import { engageAxios, toolkitAxios } from "@/env";

export default createStore({
  state: {
    getLoggedInUser: {},
    employeeList: [],
    getRemittanceData: "",
    employeesLoaded: false,
    getTickets: [],
    getTickesLoading: false,
    latestRemittance: [],
    loaded: false,
    remittanceLoaded: false,
    fundedAndUnfunded: "",
    loadingFundedAndUnfunded: false,
    resetOrSignup: "forgot",
    closeModal: false,
    paymentLoading: false,
    paymentHistoryData: [],
    error: "",
    proofOfFundLoading: false,
    proofOfRemittanceError: null,
    global_payment_start_date: null,
    global_payment_end_date: null,
    proof_of_fund_data: [],
    proof_of_fund_letterhead_data: null,
    getContact: null,
  },
  plugins: [createPersistedState()],
  mutations: {
    GET_CURRENTLY_LOGGED_IN_USER(state, getLoggedInUser) {
      state.getLoggedInUser = getLoggedInUser;
    },
    GET_REMITTANCE_DATA(state, getRemittanceData) {
      state.getRemittanceData = getRemittanceData;
    },
    GET_LATEST_REMITTANCE_DATA(state, latestRemittance) {
      state.latestRemittance = latestRemittance;
    },
    GET_LOADED_STATUS(state, loaded) {
      state.loaded = loaded;
    },
    GET_REMITTANCE_LOADED_STATUS(state, remittanceLoaded) {
      state.remittanceLoaded = remittanceLoaded;
    },
    GET_ALL_EMPLOYEES(state, employeeList) {
      state.employeeList = employeeList;
    },
    GET_ALL_EMPLOYEES_LOADING_STATUS(state, employeesLoaded) {
      state.employeesLoaded = employeesLoaded;
    },
    GET_ALL_TICKETS(state, getTickets) {
      state.getTickets = getTickets;
    },
    GET_ALL_TICKETS_LOADING_STATUS(state, getTickesLoading) {
      state.getTickesLoading = getTickesLoading;
    },
    GET_ALL_FUNDED_AND_UNFUNDED(state, fundedAndUnfunded) {
      state.fundedAndUnfunded = fundedAndUnfunded;
    },
    GET_ALL_LOADING_FUNDED_AND_UNFUNDED(state, loadingFundedAndUnfunded) {
      state.loadingFundedAndUnfunded = loadingFundedAndUnfunded;
    },
    GET_ACTION_NAME(state, resetOrSignup) {
      state.resetOrSignup = resetOrSignup;
    },
    CLOSE_MODAL(state, closeModal) {
      state.closeModal = closeModal;
    },
    PAYMENT_HISTORY_LOADING(state, paymentLoading) {
      state.paymentLoading = paymentLoading;
    },
    GET_PAYMENT_HISTORY_DATA(state, paymentHistoryData) {
      state.paymentHistoryData = paymentHistoryData;
    },
    GET_ERROR(state, error) {
      state.error = error;
    },
    PROOF_OF_REMITTANCE_ERROR(state, proofOfRemittanceError) {
      state.proofOfRemittanceError = proofOfRemittanceError;
    },
    PROOF_OF_FUND_LOADING(state, proofOfFundLoading) {
      state.proofOfFundLoading = proofOfFundLoading;
    },
    GLOBAL_START_DATE(state, global_payment_start_date) {
      state.global_payment_start_date = global_payment_start_date;
    },
    GLOBAL_END_DATE(state, global_payment_end_date) {
      state.global_payment_end_date = global_payment_end_date;
    },
    GET_CURRENT_CONTACT(state, getContact) {
      state.getContact = getContact;
    },
    GET_PROOF_FUND_DATA(state, proof_of_fund_data) {
      state.proof_of_fund_data = proof_of_fund_data;
    },
    GET_PROOF_FUND_LETTERHEAD_DATA(state, proof_of_fund_letterhead_data) {
      state.proof_of_fund_letterhead_data = proof_of_fund_letterhead_data;
    },
  }, //
  actions: {
    getCurrentUser: ({ commit }, getLoggedInUser) =>
      commit("GET_CURRENTLY_LOGGED_IN_USER", getLoggedInUser),

    getCurrentContact: ({ commit }, getContact) =>
      commit("GET_CURRENT_CONTACT", getContact),

    changeStartDate: ({ commit }, date) => commit("GLOBAL_START_DATE", date),

    changeEndDate: ({ commit }, date) => commit("GLOBAL_END_DATE", date),

    async getAllRemittanceData({ commit }) {
      commit("GET_REMITTANCE_LOADED_STATUS", true);
      return await toolkitAxios
        .post("employer/remittance-payment")
        .then((response) => {
          commit("GET_REMITTANCE_DATA", response.data.data);
          commit("GET_REMITTANCE_LOADED_STATUS", false);
        });
    },

    async getLatestRemittance({ commit }) {
      commit("GET_LOADED_STATUS", false);
      return await toolkitAxios
        .post("employer/remittancehistory/latest")
        .then((response) => {
          commit("GET_LATEST_REMITTANCE_DATA", response.data.data);
          commit("GET_LOADED_STATUS", true);
        });
    },

    async getLatestFundedAndUnfunded({ commit }) {
      commit("GET_ALL_LOADING_FUNDED_AND_UNFUNDED", false);
      return await toolkitAxios
        .post("employer/fundedandunfunded")
        .then((res) => {
          commit("GET_ALL_FUNDED_AND_UNFUNDED", res.data.data);
          commit("GET_ALL_LOADING_FUNDED_AND_UNFUNDED", false);
        });
    },

    async getTickets({ commit }) {
      commit("GET_ALL_TICKETS_LOADING_STATUS", true);
      return await engageAxios
        .get(`crm/case/employer/getcases/${this.state.getLoggedInUser?.code}`)
        .then((response) => {
          // console.log("response", response);
          commit("GET_ALL_TICKETS", response.data.data);
          commit("GET_ALL_TICKETS_LOADING_STATUS", false);
        });
    },

    async getRemittance({ commit }, data) {
      commit("PAYMENT_HISTORY_LOADING", true);
      return await toolkitAxios
        .post(`employer/remittancehistory`, data)
        .then((response) => {
          commit("GET_PAYMENT_HISTORY_DATA", response.data.remittance);
          commit("GLOBAL_START_DATE", data.start_date);
          commit("GLOBAL_END_DATE", data.end_date);
        })
        .catch(() => {
          commit("GET_ERROR", "Something went wrong please retry");
        })
        .finally(() => {
          commit("PAYMENT_HISTORY_LOADING", false);
        });
    },

    async proofOfFund({ commit }, data) {
      commit("PROOF_OF_FUND_LOADING", true);
      return await toolkitAxios
        .post(`employer/remittancehistory/generate`, data)
        .then((response) => {
          // console.log(response.data.data.url.remittance.remittances);
          commit("GET_PROOF_FUND_DATA", response.data.data.url);
          // commit('GET_PROOF_FUND_LETTERHEAD_DATA', response.data.data.url)
        })
        .catch(() => {
          commit(
            "PROOF_OF_REMITTANCE_ERROR",
            "Error generating proof of remittance, please try again"
          );
        })
        .finally(() => {
          commit("PROOF_OF_FUND_LOADING", false);
        });
    },

    async getAllEmployees({ commit }) {
      commit("GET_ALL_EMPLOYEES_LOADING_STATUS", true);
      commit("GET_ERROR", null);
      return await toolkitAxios
        .post(`employer/staffs`)
        .then((response) => {
          commit("GET_ALL_EMPLOYEES", response.data.data);
        })
        .catch(() => {
          commit(
            "GET_ERROR",
            "Error fetching employees list, please try again"
          );
        })
        .finally(() => {
          commit("GET_ALL_EMPLOYEES_LOADING_STATUS", false);
        });
    },

    getActionName: ({ commit }, resetOrSignup) =>
      commit("GET_ACTION_NAME", resetOrSignup),
  },
  getters: {
    // get first letter in first and last name, though I am getting the first and last index after splitting the name
    getLoggedInUserFirstAndLast: (state) =>
      (
        state.getLoggedInUser.name.split(" ")[0] +
        " " +
        state.getLoggedInUser.name.split(" ")[1]
      )

        .match(/(^\S\S?|\b\S)?/g)
        .join("")
        .match(/(^\S|\S$)?/g)
        .join("")
        .toUpperCase(),

    // doing the same splitting and getting first letter of first and last name.
    getRMUFirstAndLast: (state) =>
      (
        state.getLoggedInUser.rmu_name?.split(" ")[0] +
        " " +
        state.getLoggedInUser.rmu_name?.split(" ")[1]
      )
        .match(/(^\S\S?|\b\S)?/g)
        .join("")
        .match(/(^\S|\S$)?/g)
        .join("")
        .toUpperCase(),
  },
});
